// extracted by mini-css-extract-plugin
export default {"Box":"repo-list-module__Box--BuAKW","Text":"repo-list-module__Text--MRulV"};